//
//
//
//
//
//

import SoftwareRequired from '../items/ProductInfoItemSoftware.vue';

export default {
  name: 'product-card-info-video-template',
  components: {
    SoftwareRequired,
  },
  props: {
    element: Object,
  },
};
